/* Facets for the imported catalogue. Product prices always come from Shopify. */
(() => {
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  const quote = value => `"${String(value).replace(/\\/g,'\\\\').replace(/"/g,'\\"')}"`;
  const excludeService = query => {
    const source = String(query || '').trim();
    if (source.includes('-tag:"service-garantie"')) return source;
    return source && source !== '*' ? `(${source}) AND -tag:"service-garantie"` : '-tag:"service-garantie"';
  };
  const visibleQuery = query => {
    const visible = String(query || '').replace(/\s+(?:AND\s+)?-tag:"service-garantie"/g,'').replace(/^-tag:"service-garantie"$/,'').trim().replace(/^\((.*)\)$/,'$1');
    return visible === '*' ? '' : visible;
  };
  function resolveOptions(metadata, context, groups, nativeOptions = []) {
    if (!metadata) return [];
    const native = new Set(nativeOptions.map(normalize));
    const scope = metadata.contexts[context] || metadata.contexts.all || {};
    const wanted = [];
    if (groups.includes('condition') && !native.has('etat')) wanted.push('condition');
    if (groups.includes('colour') && !native.has('couleur')) wanted.push('colour');
    if (groups.includes('configuration') && !native.has('configuration')) wanted.push('storage','ram','configuration');
    return wanted.map(id => {
      const allowed = new Set(scope[id] || []);
      const values = (metadata.options[id] || []).filter(o => allowed.has(o.id));
      return {id:`facet_${id}`, dimension:id, label:metadata.groups[id].label, options:values.map(o => ({...o,rule:{tag:o.tag}}))};
    }).filter(group => group.options.length > 1);
  }
  function exactExclusions(metadata, selected) {
    const index = metadata?.variant_index;
    if (!index) return [];
    const ids = new Map(index.tags.map((tag,i) => [tag,i]));
    const dimensions = index.dimensions.map((key,i) => ({i,chosen:new Set((selected[key] || []).map(tag=>ids.get(tag)).filter(id=>id!==undefined))})).filter(d=>d.chosen.size);
    if (dimensions.length < 2) return [];
    // A product with each attribute separately must also have a single matching variant.
    return index.products.filter(product => dimensions.every(d=>product.values[d.i].some(id=>d.chosen.has(id))) && !product.variants.some(variant=>dimensions.every(d=>d.chosen.has(variant[d.i])))).map(product=>product.tag);
  }
  window.RAFacets = {normalize,quote,excludeService,visibleQuery,resolveOptions,exactExclusions};
})();
